module.exports = __webpack_public_path__ + "img/history_timeline_12.d9d20684.png";